import React, { useRef, useEffect, useCallback } from "react";
import { delay } from "lodash";
import { DragAnimation } from "../DragAnimation";
import * as S from "./styles";

export const Slide5: React.FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const compositionRef = useRef<HTMLImageElement>(null);

  const handleScroll = useCallback(() => {
    if (wrapperRef.current && compositionRef.current) {
      wrapperRef.current.scrollBy(
        compositionRef.current.offsetWidth / 2 -
          wrapperRef.current.offsetWidth / 2,
        0
      );
    }
  }, []);

  useEffect(() => {
    delay(handleScroll, 1000);
  }, [handleScroll]);
  return (
    <S.Container>
      <DragAnimation />
      <S.Wrapper ref={wrapperRef}>
        <S.Composition ref={compositionRef} />
      </S.Wrapper>
    </S.Container>
  );
};
